import DataTable from '@semcore/ui/data-table';

export const Table = DataTable;
